import { Directive, output } from '@angular/core';
import {ISearchParams} from '../../types/ICart';

@Directive()
export abstract class LookupTabBase {
  search = output<ISearchParams>()
}
